import { render, staticRenderFns } from "./detail_lifeGuard.vue?vue&type=template&id=1a28800d&scoped=true&"
import script from "./detail_lifeGuard.vue?vue&type=script&lang=js&"
export * from "./detail_lifeGuard.vue?vue&type=script&lang=js&"
import style0 from "./detail_lifeGuard.vue?vue&type=style&index=0&id=1a28800d&scoped=true&lang=css&"
import style1 from "./detail_lifeGuard.vue?vue&type=style&index=1&lang=css&"
import style2 from "./detail_lifeGuard.vue?vue&type=style&index=2&id=1a28800d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a28800d",
  null
  
)

export default component.exports